export const HOME_PAGE_URL = '/home';
export const ADVISER_HOME_PAGE_URL = '/adviser/home';
